import { render, staticRenderFns } from "./ad-langingpage.vue?vue&type=template&id=197953f7&scoped=true"
import script from "./ad-langingpage.vue?vue&type=script&lang=js"
export * from "./ad-langingpage.vue?vue&type=script&lang=js"
import style0 from "./ad-langingpage.vue?vue&type=style&index=0&id=197953f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197953f7",
  null
  
)

export default component.exports